/**
 * Shopify CRM CSV export helper
 */
import type { ShopifyCustomer } from '../types';

// Export customers to CSV for SendGrid
export function exportToCSV(customers: ShopifyCustomer[]): void {
  const headers = ['email', 'first_name', 'last_name', 'total_spent', 'order_count', 'stores', 'last_order_date', 'city', 'state', 'country', 'phone'];

  const rows = customers.map(c => {
    const nameParts = c.name.split(' ');
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';

    return [
      c.email,
      firstName,
      lastName,
      c.totalSpent.toFixed(2),
      c.orderCount.toString(),
      c.stores.join('; '),
      c.lastOrderDate || '',
      c.city || '',
      c.state || '',
      c.country || '',
      c.phone || '',
    ].map(field => `"${(field || '').replace(/"/g, '""')}"`).join(',');
  });

  const csv = [headers.join(','), ...rows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `shopify-customers-${new Date().toISOString().split('T')[0]}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
